export default [
  {
    name: 'English',
    file: 'en-US.js',
    flag: 'us',
    code: 'en',
    rtl: false
  },
  {
    name: 'Français',
    file: 'fr-FR.js',
    flag: 'fr',
    code: 'fr',
    rtl: false
  },
  {
    name: 'עברית',
    file: 'he-IL.js',
    flag: 'il',
    code: 'he',
    rtl: true
  }
]
